export const CONVERSION_TYPES = ['external_customer_interest', 'external_vehicle_checkout'] as const;
export const CUSTOMER_TYPES = ['Business', 'Internal', 'Private'] as const;
export const CAR_ID_PARAM = 'carId' as const;
export const EXTERIOR_COLOR_INTERNAL_CODE_PARAM = 'exteriorColorInternalCode' as const;
export const FACTORY_MODEL_PARAM = 'factoryModel' as const;
export const MODEL_YEAR_PARAM = 'modelYear' as const;
export const CP_ETA_PARAM = 'cpEta' as const;
export const ETA_LOCATION_PARAM = 'etaLocation' as const;
export const SSN_PARAM = 'ssn' as const;
export const KATASHIKI_PARAM = 'katashiki' as const;
export const SUFFIX_PARAM = 'suffix' as const;
export const VIN_PARAM = 'vin' as const;
export const OPPORTUNITY_ID_PARAM = 'opp_id' as const;
export const OPPORTUNITY_ORIGIN_PARAM = 'opp_source' as const;
export const MAX_QUANTITY = 400 as const;
export const ORDER_STATUS = ['Cancelled', 'Created', 'Failed', 'Fulfilled', 'Ordered'] as const;
export const ROCKAR_CUSTOMER_NOT_AUTHENTICATED_MESSAGE =
	'[GraphQL] Failed to getCustomerIdFromSsoToken. getCustomerIdByUserToken error. Request failed with status code 401';
export const TAX_RATE_PARAM = 'taxRate' as const;
export const UPHOLSTERY_INTERNAL_CODE_PARAM = 'upholsteryInternalCode' as const;
export const ES_TOYOTA_EASY_EASY_COMPLET = 'ES_TOYOTA_EASY_EASY_COMPLET';
export const ES_TOYOTA_EASY_EASY_PLUS = 'ES_TOYOTA_EASY_EASY_PLUS';
